import React from 'react';
import { Link } from 'react-router-dom';

const DeleteAccount = () => {
  return (
    <div className="legal-page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">
            <Link to="/" className="logo-link">
              <h1>Pebble</h1>
            </Link>
          </div>
          <nav className="nav">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/privacy" className="nav-link">Privacy</Link>
            <Link to="/terms" className="nav-link">Terms</Link>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="legal-content">
        <div className="container">
          <h1>Delete Your Pebble Account</h1>
          <p className="last-updated">
            Pebble: Baby Tracker — published by RASCAL APPS LLC
          </p>

          <section>
            <h2>How to request account deletion</h2>
            <p>
              You can delete your Pebble account and its data directly in the app, at any time. No email or
              waiting period is required.
            </p>
            <ol>
              <li>Open the Pebble app and sign in.</li>
              <li>Go to <strong>Settings</strong>.</li>
              <li>Tap <strong>Account Settings</strong>.</li>
              <li>Tap <strong>Delete Account</strong>.</li>
              <li>
                Confirm twice — Pebble asks a second time, because deletion is immediate and cannot be
                reversed.
              </li>
            </ol>
            <p>
              If you can no longer sign in, email{' '}
              <strong>privacy@pebble.baby</strong> with the subject line{' '}
              <strong>Account Deletion Request</strong>, from the email address on the account. We will verify
              ownership and delete the account for you within 30 days.
            </p>
          </section>

          <section>
            <h2>What gets deleted</h2>
            <p>
              Deleting your account permanently removes the following, immediately and without a recovery
              window:
            </p>
            <ul>
              <li>
                <strong>Your account:</strong> your sign-in credentials, email address, name, app preferences,
                and notification settings
              </li>
              <li>
                <strong>Every baby profile you created:</strong> name, birth date, and profile details
              </li>
              <li>
                <strong>All tracking history for those babies:</strong> feeding, sleep, diaper changes, growth
                measurements, and milestones
              </li>
              <li>
                <strong>All photos you uploaded</strong> for those babies, deleted from our storage
              </li>
            </ul>
          </section>

          <section>
            <h2>What is kept, and for how long</h2>
            <ul>
              <li>
                <strong>Babies shared with you by someone else:</strong> these belong to the parent who created
                them, so they are not deleted. Your access is removed and your email address is taken off the
                sharing list.
              </li>
              <li>
                <strong>Subscription and purchase records:</strong> billing history is held by Apple or Google,
                not by Pebble, and is governed by their retention policies. Deleting your Pebble account does
                not cancel an active subscription — cancel that in the App Store or Google Play.
              </li>
              <li>
                <strong>Crash and diagnostic logs:</strong> anonymous stability data may persist for up to 90
                days before being purged automatically. It is not linked to your account after deletion.
              </li>
              <li>
                <strong>Routine backups:</strong> residual copies may remain in encrypted backups for up to 30
                days, after which they expire.
              </li>
            </ul>
          </section>

          <section>
            <h2>Deleting some data without deleting your account</h2>
            <p>
              You do not have to delete your whole account to remove information. Individual feedings, sleep
              sessions, diaper changes, growth entries, milestones, and photos can each be deleted from within
              the app, and a baby profile can be removed on its own.
            </p>
          </section>

          <section>
            <h2>Questions</h2>
            <p>
              <strong>Email:</strong> privacy@pebble.baby<br />
              <strong>Subject Line:</strong> Account Deletion Request
            </p>
          </section>

          <div className="back-to-home">
            <Link to="/" className="btn btn-primary">Back to Home</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DeleteAccount;
